import React from 'react'
import { Box } from '@mui/material'
import { INTERAX_COLORS } from '../../constants/interaxColors'

/**
 * ActiveGlow - The orange glow halo effect (Ellipse 116 from Figma)
 *
 * Creates an ambient orange glow in the top-right corner of active menu items.
 * This is a decorative element that adds depth and visual interest.
 */
export const ActiveGlow: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        width: '50px',
        height: '50px',
        left: '179px',
        top: '-8px',
        background: INTERAX_COLORS.sun,
        filter: 'blur(50px)',
        pointerEvents: 'none',
        zIndex: 3
      }}
    />
  )
}
